"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { __, getPermalink } from "@/lib/i18n/functions";
import { Locales } from "@/lib/i18n";
import { Toast } from "@/components/atoms/toast";
import { Graphics } from "@/components/graphics";

type ThankYouHeaderProps = {
  readonly locale: Locales;
};

const ThankYouHeader = ({ locale }: ThankYouHeaderProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const workflowError = searchParams.get("error");

  return (
    <>
      <header className="flex flex-col items-center gap-5 md:items-start">
        {!workflowError ? (
          <>
            <Graphics.checkCircle />
            <h2 className="font-cabinet-grotesk text-center text-2xl font-medium md:text-3xl">
              {__("Your request has been sent successfully.", locale)}
            </h2>
            <p className="md:font-cabinet-grotesk max-md:text-primary-light leading-body-md text-lg max-md:text-center">
              {__("A summary will be sent to you by email.", locale)} <br />
              {__(
                "One of our staff members will send you a final, adjusted quote by email within the next few days.",
                locale
              )}
            </p>
          </>
        ) : (
          <Toast
            id="workflow-error"
            title={__("An error has occurred.", locale)}
            description={__("Please contact us at rent@festi.be", locale)}
            type="warning"
            className="shadow-none max-md:max-w-none max-sm:max-w-none"
            button={{ label: __("Contact us", locale), onClick: () => router.push(getPermalink(locale, "contact")) }}
          />
        )}
      </header>
    </>
  );
};

export default ThankYouHeader;
